export default __webpack_public_path__ + "static/media/icon_tools.a6034cde.svg";